// @flow @jsx h

import { SerumSmartPicture, Slide } from '@nrk/dh-feature-components'
import VideoPlayer from '../VideoPlayer'
import { h } from 'preact'
import style from './index.css'

import type { DefaultSlideProps } from './types'

function DefaultSlide (props: DefaultSlideProps) {
  const {
    active,
    mediaBaseUrl,
    muted,
    onAnalyticsEvent,
    onToggleMute,
    stacked,
    viewport,
    visible
  } = props
  const { media } = props.value

  if (!media) {
    return <Slide className={style.visualStory__slide} stacked={stacked} />
  }

  switch (media.type) {
    case 'image':
      return (
        <Slide className={style.visualStory__slide} stacked={stacked}>
          <SerumSmartPicture horizontal={media} vertical={media} alt='' />
        </Slide>
      )

    case 'video':
      return (
        <Slide className={style.visualStory__slide} stacked={stacked}>
          <VideoPlayer
            loop
            muted={muted}
            captions={
              media.captions &&
              media.captions.map(caption => {
                return {
                  in: Number(caption.in),
                  out: Number(caption.out),
                  text: caption.text
                }
              })
            }
            onPlay={() => {
              onAnalyticsEvent({ action: `video/PLAY/${media.id}` })
            }}
            onPause={() => {
              onAnalyticsEvent({ action: `video/PAUSE/${media.id}` })
            }}
            onToggleMute={onToggleMute}
            playing={active && visible}
            horizontal={{
              poster: `${mediaBaseUrl}${media.horizontal.poster}`,
              sources: media.horizontal.sources.map(source => {
                return {
                  type: source.type,
                  src: `${mediaBaseUrl}${source.src}`
                }
              })
            }}
            vertical={{
              poster: `${mediaBaseUrl}${media.vertical.poster}`,
              sources: media.vertical.sources.map(source => {
                return {
                  type: source.type,
                  src: `${mediaBaseUrl}${source.src}`
                }
              })
            }}
            viewport={viewport}
          />
        </Slide>
      )

    default:
      return <Slide className={style.visualStory__slide} stacked={stacked} />
  }
}

export default DefaultSlide
